import React from 'react'
import styles from './styles.css'
import {Link} from 'react-router-dom'
import ToggleOn from 'react-icons/lib/fa/toggle-on'
import ToggleOff from 'react-icons/lib/fa/toggle-off'
import useMutate from 'apollo-hooks/lib/useMutate'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import useMessage from 'App/hooks/useMessage'
import gql from 'graphql-tag'
import ToggleRow from '../../shared/ToggleRow'
import AutoForm from 'App/components/AutoForm'

export default function AgentList({agents, onToggleClick}) {
  const mutate = useMutate()
  const showMessage = useMessage()

  const {countries} = useQuery({
    query: gql`
      query {
        countries {
          code
          emoji
        }
      }
    `
  })

  async function toggleCountryPreference({userId, value}) {
    await mutate({
      mutation: gql`
        mutation toggleCountryPreference($userId: ID, $value: ID) {
          toggleCountryPreference(userId: $userId, value: $value)
        }
      `,
      variables: {userId, value},
      refetchQueries: ['getMe', 'getAgents']
    })
    showMessage('Preferencias actualizadas')
  }

  return (
    <div>
      <h3>Preferencias para distribuir los chats</h3>
      <div className={styles.container}>
        <div className={styles.row}>
          <div className={styles.name}>
            <h4>Nombre ({agents.length})</h4>
          </div>
          <div className={styles.status}>
            <h4>Status</h4>
          </div>
          <div className={styles.item}>
            <h4>Roles</h4>
          </div>
          <div className={[styles.item, styles.limitColumn].join(' ')}>
            <h4>Max. chats</h4>
          </div>
          <div className={styles.item}>
            <h4>Preferencias</h4>
          </div>
        </div>
        {agents.map(({_id, fullName, activeForAutoAssignChat, roles, inboxPreference}) => (
          <div className={styles.row} key={_id}>
            <div className={styles.name}>
              <Link to={`/admin/users/${_id}`}>{fullName}</Link>
            </div>
            <div className={styles.status}>
              <div
                className={styles.statusToggle}
                role="button"
                onClick={() => {
                  onToggleClick({userId: _id, activeForAutoAssignChat: !activeForAutoAssignChat})
                }}>
                {activeForAutoAssignChat ? (
                  <ToggleOn color="#1bb157" size={20} />
                ) : (
                  <ToggleOff color="#9CA3AF" size={20} />
                )}
              </div>
            </div>
            <div className={styles.item}>{roles.join(', ')}</div>
            <div className={[styles.item, styles.limitColumn].join(' ')}>
              <AutoForm
                mutation="updateMaxChatsPreference"
                omit="userId"
                autoSave={true}
                doc={{userId: _id, maxChats: inboxPreference.maxChats}}
              />
            </div>
            <div className={styles.item}>
              {countries.map(({code, emoji}) => (
                <ToggleRow
                  key={code}
                  label={`${emoji}`}
                  active={inboxPreference.countryCodes.includes(code)}
                  onToggle={() => toggleCountryPreference({userId: _id, value: code})}
                  rowStyle="shortRow"
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
